function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP title
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { licenceExpiry } from '../../actions/index';
import DateInput from '../date-input/DateInput';
import moment from 'moment';
import './LicenceExpiry.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export class LicenceExpiry extends React.Component {
  render() {
    const {
      licenceExpiry,
      setLicenceExpiry
    } = this.props;
    return /*#__PURE__*/_jsx(DateInput, {
      handleChange: setLicenceExpiry,
      label: "Licence Expiry",
      maxFuture: moment().add(10, 'years'),
      name: "licenceExpiry",
      onBlur: setLicenceExpiry,
      range: "future",
      section: "licence-details",
      values: {
        licenceExpiry
      }
    });
  }
}
_defineProperty(LicenceExpiry, "defaultProps", {
  licenceExpiry: {
    value: ''
  }
});
const mapStateToProps = ({
  licenceExpiry
}) => {
  return {
    licenceExpiry
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setLicenceExpiry: value => {
      dispatch(licenceExpiry(value));
    }
  };
};
const VisibleLicenceExpiry = connect(mapStateToProps, mapDispatchToProps)(LicenceExpiry);
export default VisibleLicenceExpiry;